/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateExamBlockDto
 */
export interface CreateExamBlockDto {
    /**
     * 
     * @type {string}
     * @memberof CreateExamBlockDto
     */
    reason: string;
}

/**
 * Check if a given object implements the CreateExamBlockDto interface.
 */
export function instanceOfCreateExamBlockDto(value: object): value is CreateExamBlockDto {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function CreateExamBlockDtoFromJSON(json: any): CreateExamBlockDto {
    return CreateExamBlockDtoFromJSONTyped(json, false);
}

export function CreateExamBlockDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExamBlockDto {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function CreateExamBlockDtoToJSON(value?: CreateExamBlockDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
    };
}

